import Vue from "vue";

export default {
  namespaced: true,
  state: {
    _loading: {
      login: false,
      logout: false
    },
    authKey: "",
    userId: "",
    userName: "",
    userFullName: "",
    userEmail: "",
    userType: "",
    userCompany: "",
    userRole: "",
    userIsParent: 0,
    userExtra: "",
    apiKey: "AtmgUpne2UFBMCgV"
  },
  mutations: {
    userLogin(state, payload) {
      state.authKey = payload.auth_key;
      state.userName = payload.user_name;
      state.userRole = payload.user_role;
      state.userIsParent = payload.is_parent;
      state.userId = payload.user_id;
      state.userType = payload.user_type;
    },
    userDetails(state, payload) {
      state.userFullName = payload.user_fullname;
      state.userEmail = payload.user_email;
      state.userCompany = payload.user_company;
      state.userExtra = payload.user_extradata;
    },
    delete(state) {
      state.authKey = "";
      state.userId = "";
      state.userName = "";
      state.userFullName = ""
      state.userEmail = "";
      state.userType = "";
      state.userCompany = "";
      state.userRole = "";
      state.userIsParent = 0;
    }
  },
  actions: {
    register(context, payload) {
      const url = "https://saas-api.xendity.com/v1/auth/register";
      const json = {
        parent: 0, //master account
        username: payload.username,
        password: payload.password,
        email: payload.email,
        type: payload.type,
        company: payload.company,
        full_name: payload.full_name,
        role_id: "user",
        extra_data: "",
        created_by: 0
      }

      return new Promise((resolve, reject) => {
        Vue.http.post(url, json).then(response => {
          if (response.body.success == false)
            resolve({
              'status': 400,
              'error_message': response.body.data.message
            })
          else {
            resolve(response.body.data)
          }
        })
      })
    },
    login(context, payload) {
      const url = "https://saas-api.xendity.com/v1/auth/login";
      const json = {
        username: payload.username,
        password: payload.password
      }

      return new Promise((resolve, reject) => {
        Vue.http.post(url, json).then(response => {
          if (response.body.success == false)
            resolve({
              'status': 400,
              'error_message': response.body.data.message
            })
          else {
            context.commit('userLogin', {
              auth_key: response.body.data.auth_key,
              user_name: payload.username,
              user_role: response.body.data.role_id,
              is_parent: response.body.data.is_parent,
              user_id: response.body.data.user_id,
              user_type: response.body.data.user_type
            })
            resolve(response.body.data)
          }
        })
      })
    },
    verify(context, payload) {
      const url = "https://saas-api.xendity.com/v1/auth/verify";
      const json = {
        username: payload.username,
        verify_token: payload.verify_token
      }

      return new Promise((resolve, reject) => {
        Vue.http.post(url, json).then(response => {
          if (response.body.success == false)
            resolve({
              'status': 400,
              'error_message': response.body.data.message
            })
          else {
            resolve(response.body.data)
          }
        })
      })
    },
    resend(context, payload) {
      const url = "https://saas-api.xendity.com/v1/auth/resend-verify";
      const json = {
        username: payload.username
      }

      return new Promise((resolve, reject) => {
        Vue.http.post(url, json).then(response => {
          if (response.body.success == false)
            resolve({
              'status': 400,
              'error_message': response.body.data.message
            })
          else {
            resolve(response.body.data)
          }
        })
      })
    },
    reset(context, payload) {
      const url = "https://saas-api.xendity.com/v1/auth/reset-password";
      const json = {
        username: payload.username,
        password: payload.password,
        password_reset_token: payload.token
      }

      return new Promise((resolve, reject) => {
        Vue.http.post(url, json).then(response => {
          if (response.body.success == false)
            resolve({
              'status': 400,
              'error_message': response.body.data.message
            })
          else {
            resolve(response.body.data)
          }
        })
      })
    },
    request(context, payload) {
      const url = "https://saas-api.xendity.com/v1/auth/request-reset";
      const json = {
        username: payload.username
      }

      return new Promise((resolve, reject) => {
        Vue.http.post(url, json).then(response => {
          if (response.body.success == false)
            resolve({
              'status': 400,
              'error_message': response.body.data.message
            })
          else {
            resolve(response.body.data)
          }
        })
      })
    },
    logout(context) {
      const url = "https://saas-api.xendity.com/v1/auth/logout";

      const json = {
        username: context.state.userName,
        auth_key: context.state.authKey
      }

      return new Promise((resolve, reject) => {
        Vue.http.post(url, json).then(response => {
          if (response.body.success == false)
            resolve({
              'status': 400,
              'error_message': response.body.data.message
            })
          else {
            context.commit('delete')
            resolve(response.body.data)
          }
        })
      })
    },
    detail(context) {
      const url = "https://saas-api.xendity.com/v1/auth/get-detail";
      const json = {
        username: context.state.userName,
        auth_key: context.state.authKey
      }

      return new Promise((resolve, reject) => {
        Vue.http.post(url, json).then(response => {
          if (response.body.success == false)
            resolve({
              'status': 400,
              'error_message': response.body.data.message
            })
          else {
            context.commit('userDetails', {
              user_fullname: response.body.data.user.full_name,
              user_email: response.body.data.user.email,
              user_company: response.body.data.user.company,
              user_extradata: response.body.data.user.extra_data
            })
            resolve(response.body.data)
          }
        })
      })
    }
  }
};